"use client";

import * as React from "react";
import { ChevronDown, Search, Star, Tag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Input } from "@/components/ui/input";
export default function FilterBar() {
  const [searchExpanded, setSearchExpanded] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);
  const ratings = [{
    label: "All Ratings",
    value: "all"
  }, {
    label: "5 Stars",
    value: "5"
  }, {
    label: "4+ Stars",
    value: "4"
  }, {
    label: "3+ Stars",
    value: "3"
  }];
  const flavors = [{
    label: "All Flavors",
    value: "all"
  }, {
    label: "Chocolatey",
    value: "chocolate"
  }, {
    label: "Fruity",
    value: "fruit"
  }, {
    label: "Nutty",
    value: "nut"
  }, {
    label: "Floral",
    value: "floral"
  }, {
    label: "Caramel",
    value: "caramel"
  }];
  return <div className={`bg-background/80 backdrop-blur-md border-b border-border shadow-soft sticky top-0 z-40 transition-all duration-[350ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] ${isVisible ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"}`} data-wvc-section="filter-bar">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3 gap-4">
          {}
          <div className="flex items-center gap-2">
            {}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="gap-1.5 transition-all duration-[250ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:shadow-medium hover:-translate-y-0.5">
                  <Star className="size-3.5" />
                  <span className="hidden sm:inline">Rating</span>
                  <ChevronDown className="size-3.5 transition-transform duration-200 data-[state=open]:rotate-180" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-40 animate-in fade-in-0 zoom-in-95 duration-200">
                {ratings.map((rating, i) => <DropdownMenuItem key={rating.value} data-index={i} className="cursor-pointer transition-colors duration-150">
                    {rating.label}
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            {}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="gap-1.5 transition-all duration-[250ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:shadow-medium hover:-translate-y-0.5">
                  <Tag className="size-3.5" />
                  <span className="hidden sm:inline">Flavor</span>
                  <ChevronDown className="size-3.5 transition-transform duration-200 data-[state=open]:rotate-180" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-40 animate-in fade-in-0 zoom-in-95 duration-200">
                {flavors.map((flavor, i) => <DropdownMenuItem key={flavor.value} data-index={i} className="cursor-pointer transition-colors duration-150">
                    {flavor.label}
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            {}
            <div className="relative flex items-center">
              <Input type="text" placeholder="Search roasters..." className={`pl-9 transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] ${searchExpanded ? "w-52" : "w-32"} sm:w-52`} onFocus={() => setSearchExpanded(true)} onBlur={() => setSearchExpanded(false)} />
              <Search className="size-4 text-muted-foreground absolute left-3 pointer-events-none" />
            </div>
          </div>

          {}
          <Button className="gap-2 transition-all duration-[250ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0">
            Apply Filters
          </Button>
        </div>
      </div>
    </div>;
}